import adresseBo from '../Adresse';

export default class clientBo {
    _personnes = [];
    _professionnels = [];

    get client() {
        return {
            numero: 0,
            typeClient: 'part',
            obs: ''
        };
    }

    get personnes() {
        return this._personnes;
    }

    set personnes(newPersonnes) {
        this._personnes = newPersonnes;
    }

    get professionnel() {
        return this._professionnels;
    }

    set professionnel(newProfessionnel) {
        this._professionnels = newProfessionnel;
    }
}


// WEBPACK FOOTER //
// ./src/components/data/client/Client.js